import { Select } from '@mantine/core';
import { useClientScope } from '../../hooks/useClientScope';

/**
 * Přepínač organizací — jen pro admin API klíč. Backend filtruje všechna data podle
 * client_id, takže tahle volba mění úplně celý obsah aplikace.
 */
export function ClientSwitcher() {
  const { isAdmin, clients, selectedClientId, switchTo } = useClientScope();

  if (!isAdmin || clients.length < 2) return null;

  return (
    <Select
      size="xs"
      w={168}
      allowDeselect={false}
      checkIconPosition="right"
      aria-label="Organizace"
      data={clients.map((c) => ({ value: String(c.id), label: c.name }))}
      value={selectedClientId}
      onChange={(value) => value && switchTo(value)}
    />
  );
}
